import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  CloudCompCloudMig,
  CloudCompCloudApp,
  CloudCompCloudOpt,
  CloudCompDevops,
  CloudCompSupport,
  CloudCompInfra,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: CloudCompCloudMig,
    title: "Cloud Migration",
    link: "/cloud-migration",
    description:
      "TekRevol excels in modernizing applications and data storage with swift, reliable cloud migrations that minimize disruptions. Our QA engineers devise holistic test strategies by combining manual and automated testing for seamless transitions. We specialize in hybrid environment integrations, implementing cutting-edge CI/CD pipelines and robust security enhancements to meet rigorous standards.",
  },
  {
    icon: CloudCompCloudApp,
    title: "Cloud App Development",
    link: "/cloud-application-development",
    description:
      "Our dedicated team specializes in developing and supporting cloud-native applications and data warehouses tailored to your business requirements. From back-end to front-end development, we seamlessly integrate with other systems and design efficient CI/CD pipelines. Compliance is a priority, ensuring adherence to regulations like HIPAA, FDA, and PCI DSS for secure and compliant cloud solutions.",
  },
  {
    icon: CloudCompCloudOpt,
    title: "Cloud Optimization",
    link: "/cloud-cost-optimization",
    description:
      "We analyze your cloud environment to maximize service utilization and cost-effectiveness. This involves optimizing resources, leveraging Reserved and Spot instances, and eliminating redundant services. We aim to boost performance while minimizing costs to perfectly align the cloud infrastructure with your business objectives.",
  },
  {
    icon: CloudCompDevops,
    title: "DevOps Enablement",
    link: "/devops-enablement",
    description:
      "Our DevOps services streamline software development and operations, promoting collaboration and efficiency. We implement advanced CI/CD pipelines, automate testing and deployment, and optimize workflows. TekRevol enables continuous integration, continuous delivery, and infrastructure as code (IaC), ensuring rapid and reliable software releases while maintaining superior quality standards.",
  },
  {
    icon: CloudCompSupport,
    title: "Cloud Support & Maintenance",
    link: "/cloud-support-and-maintenance",
    description:
      "TekRevol offers comprehensive cloud support and maintenance services, ensuring your cloud environment remains operational and efficient. Our support team provides 24/7 monitoring, proactive issue resolution, and regular maintenance updates. We focus on optimizing performance, enhancing security, and minimizing downtime, so your business can operate smoothly and effectively in the cloud.",
  },
  {
    icon: CloudCompInfra,
    title: "Cloud Infrastructure Management",
    link: "/cloud-infrastructure",
    description:
      "TekRevol provides end-to-end support for your cloud infrastructure, from initial setup to ongoing monitoring, maintenance, and improvement. We ensure your cloud infrastructure remains safe, efficient, and rewarding for your business by adapting the modern industry needs – a secure digital ecosystem that scales as you grow.",
  },
];

function Improvise(props) {
  return (
    <div
      className="improvise_section p-100 cloud_computing_services"
      style={{ background: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Cloud Consulting Services <span>We Offer</span>
            </h2>
            <p className="impro_para">
              Get a step closer to becoming the industry leader with TekRevol’s
              future-forward cloud computing consulting services. We help
              businesses simplify the biggest challenges into rewarding
              opportunities by integrating secure and innovative solutions
              across production and market delivery operations.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <Link to={item.link}>
                      <h5>{item.title}</h5>
                    </Link>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your Cloud Needs
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
